import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { pricingPlans } from '../mock';

export const PricingSection = ({ onOpenPopup }) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Choose Your Protection Plan</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select the package that best fits your trademark protection needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`bg-white rounded-xl shadow-lg overflow-hidden transition-transform hover:scale-105 flex flex-col ${
                plan.popular ? 'ring-2 ring-primary' : ''
              }`}
            >
              {plan.popular && (
                <div className="bg-primary text-white text-center py-2 text-sm font-semibold">
                  RECOMMENDED
                </div>
              )}
              
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <div className="mb-4">
                  <span className="text-4xl font-bold text-primary">${plan.price}</span>
                  <span className="text-gray-600 text-base"> + Federal Filing Fee</span>
                </div>

                <div className="flex-1 overflow-y-auto max-h-64 mb-4">
                  <ul className="space-y-3">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <Check className="text-primary flex-shrink-0 mt-0.5" size={20} />
                        <span className="text-base text-gray-700 leading-relaxed">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <p className="text-sm text-gray-500 italic mb-4">{plan.note}</p>

                <Button
                  onClick={onOpenPopup}
                  className={`w-full h-11 text-base ${
                    plan.popular
                      ? 'bg-primary hover:bg-primary/90'
                      : 'bg-gray-900 hover:bg-gray-800'
                  }`}
                >
                  Select {plan.name}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};